import { INTERNAL_ROUTES } from '@/constants/routes'

import { getPathFromTarget, isEmailVerificationRoute, normalizePath } from '@/utils/authRoutes'

import { getStoredRequestedPath } from '@/config/sourceStorage'

const APPLICATION_ROUTES = new Set(Object.values(INTERNAL_ROUTES).map(path => normalizePath(path)))

const isExternalUrl = target => /^https?:\/\//i.test(target)

export const isApplicationRoute = target => {
  if (!target || isExternalUrl(target)) return false

  const path = normalizePath(getPathFromTarget(target))

  return APPLICATION_ROUTES.has(path)
}

export const toAbsoluteUrl = target => {
  if (!target || isExternalUrl(target) || typeof window === 'undefined') {
    return target
  }

  return target.startsWith('/') ? `${window.location.origin}${target}` : target
}

export const applyRedirect = (target, navigate) => {
  if (isApplicationRoute(target)) {
    navigate(target, { replace: true })
    return
  }

  window.location.href = toAbsoluteUrl(target)
}

export const resolvePostLoginRedirect = getReturnUrl => {
  const requestedPath = getStoredRequestedPath()

  if (requestedPath && isEmailVerificationRoute(getPathFromTarget(requestedPath))) {
    return requestedPath
  }

  return getReturnUrl()
}
